<template>
  <van-swipe :autoplay="3000" lazy-render>
    <van-swipe-item v-for="image in banners" :key="image">
      <img class="banner-img" :src="image.url" />
    </van-swipe-item>
  </van-swipe>

  <div class="company-introd">
    <div
      class="img-wrap"
      v-if="
        detailInfo.introduceImgs &&
        detailInfo.introduceImgs[0] &&
        detailInfo.introduceImgs[0].url
      "
    >
      <img :src="detailInfo.introduceImgs[0].url" />
    </div>
    <div
      class="top-box"
      :class="{
        'no-image': !(
          detailInfo.introduceImgs &&
          detailInfo.introduceImgs[0] &&
          detailInfo.introduceImgs[0].url
        ),
      }"
    >
      <div class="company-describe" v-html="detailInfo.introduce"></div>
    </div>
  </div>
  <ul v-if="detailInfo.pics?.length" class="pics-list">
    <li v-for="(item, index) in detailInfo.pics" :key="index">
      <img :src="item.url" alt="" />
    </li>
  </ul>
  <div class="product-introd" v-if="detailInfo.officialQrCodes?.length">
    <div class="qr-mask-wrap">
      <img
        :src="
          detailInfo.officialQrCodes &&
          detailInfo.officialQrCodes[0] &&
          detailInfo.officialQrCodes[0].url
        "
      />
      <img class="qr-mask" src="@/assets/img/EcodeArea.png" alt="遮罩" />
    </div>
  </div>

  <div class="footer">
    <div class="cover-img">
      <div class="contact-method">
        <div v-if="detailInfo.joinPhone" class="phone-wrap">
          <img src="../assets/img/phone.png" alt="" />
          <div>合作热线：{{ detailInfo.joinPhone }}</div>
        </div>
        <div v-if="detailInfo.email" class="email-wrap">
          <img src="../assets/img/email.png" alt="" />
          <div>合作邮箱：{{ detailInfo.email }}</div>
        </div>
      </div>
    </div>
    <div class="icon-wrap">
      <!-- <img src="../assets/img/品牌矩阵反白.png" /> -->
       <img :src="BOTTOM_IMG" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { BOTTOM_IMG } from "@/utils/constants.js";
import { getBrandDetail } from "@/api/index.js";
import { useRoute } from "vue-router";
import { trackEvent } from "@/utils/tracklog.js";

const banners = ref([]);
const detailInfo = reactive({});
const route = useRoute();

onMounted(() => {
  const id = route.params.id;
  getDetail(id);
});

// watch(
//   () => route.params.id,
//   async () => {
//     route.params.id && getDetail(route.params.id);
//   }
// );

const getDetail = (id) => {
  getBrandDetail(id).then((res) => {
    Object.assign(detailInfo, res);
    console.log("🌍 detailInfo", detailInfo);

    const { slideShows, enableCompanyName } = res;

    banners.value = slideShows;
    console.log("🍿 banners.value", banners.value);

    //埋点 业务中台
    trackEvent(
      `${id == 1 ? "会员体系" : "业务中台"}-${enableCompanyName}`,
      "浏览",
      `${id == 1 ? "会员体系" : "业务中台"}-${enableCompanyName}`,
      {},
      0,
      new Date().getTime()
    );
  });
};
// const stripHtml = (html) => {
//   if (!html) return "";
//       // 去除所有 HTML 标签，只保留文字
//       return html
//         .replace(/<[^>]+>/g, "")
//         .replace(/\s+/g, " ")
//         .trim();
// };
</script>

<style lang="scss" scoped>
.banner-img {
  width: 100%;
}

.company-introd {
  position: relative;
  width: 89vw;
  margin: 40px auto 40px;

  .img-wrap {
    width: 100%;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .top-box {
    position: absolute;
    top: 0;
    left: 0; // ⭐ 靠左边
    width: 60%; // ⭐ 左侧占 60%
    max-height: 60%; // 不超过图片高度
    padding: 10px;
    z-index: 2;
    overflow-y: auto; // 内容过多时可滚动

    // 无图片时的样式
    &.no-image {
      position: static; // 取消绝对定位
      width: 85vw;
      min-height: 5vh; // 保证有一定高度
      max-height: none;
      background-color: #f5f5f5; // 添加背景色以便区分
      padding: 10px 10px;
    }
  }

  .company-describe {
    font-size: 7px;
    // color: #333;
    
    ::v-deep * {
      box-sizing: border-box;
      font-size: inherit !important;
    }

    ::v-deep p {
      margin: 0;
      padding: 0;
    }

    ::v-deep img {
      max-width: 100%;
      height: auto;
    }

    ::v-deep h1,
    ::v-deep h2,
    ::v-deep h3,
    ::v-deep h4,
    ::v-deep h5,
    ::v-deep h6 {
      margin: 0;
      padding: 0;
    }
  }
}
.pics-list {
  width: 89vw;
  margin: 40px auto 40px;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;

  list-style: none;
  padding: 0;

  li {
    width: calc((89vw - 16px) / 3);
    display: flex;

    img {
      width: 100%;
      border-radius: 6px;
    }
  }
}
.product-introd {
  width: 100%;
  font-size: 0;
  margin: 40px auto;
  .qr-mask-wrap {
    position: relative;
    width: 100%;
    height: auto;
    img {
      width: 100%;
      display: block;
    }
    .qr-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }
  }
}
.big-img {
  font-size: 0;
}
img {
  max-width: 750rem;
}
.footer {
  background: #005250;
  padding: 20rem;
  overflow: hidden;
  height: auto;
  .cover-img {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    padding-top: 40rem;
    color: #fff;
    font-size: 12rem;
    .code-box {
      margin-right: 72rem;
      p {
        text-align: center;
        margin-bottom: 15rem;
        text-align: center;
      }
      img {
        width: 100rem;
        height: 100rem;
        display: block;
        margin: 0 auto;
      }
    }
    .contact-method {
      margin-top: 25rem;
      img {
        width: 40rem;
        height: 40rem;
        margin-right: 30rem;
      }
      .phone-wrap {
        margin-bottom: 20rem;
      }
      .phone-wrap,
      .email-wrap {
        display: flex;
        align-items: center;
      }
    }
  }
  .descible-wrap {
    display: flex;
    justify-content: space-between;
    font-size: 14rem;
    color: #b7b7b7;
    padding: 25rem 310rem;
    border-top: 1rem solid #eee;
  }
  .icon-wrap > img {
    max-width: 100%;
  }
}
</style>
